import { useEffect, useState } from 'react';
import { useDrawer } from '../../../../shared/drawer';
import { useNavigate } from 'react-router-dom';
import { Table } from "../../../../elements/table";
import { PageBody } from '../../../../elements/page-body';
import { useStore } from '../../../../shared/store';
import { RenderFilters } from '../../../../elements/render-filters';
import { AsignacionesTabFilter } from './asignaciones-tab-filter';



export const AsignacionesTab = ({
    item,
    onAction
}: {
    item?: any;
    onAction: () => void;
}) => {
    const { open, close } = useDrawer();
    const { get, set } = useStore();
    const navigate = useNavigate();
    const [refresh, setRefresh] = useState<string | null>(null);
    const [filters, setFilters] = useState<any>({});
    const [query, setQuery] = useState<any>(new URLSearchParams(filters));

    useEffect(() => {
        const filtrosGuardados = get('vehicles-filtroVehiculos') || {};
        if (Object.keys(filtrosGuardados).length > 0) {
            setFilters({ ...filtrosGuardados });
        } else {
            setFilters({});
        }
    }, []);


    const handleClose = () => {
        setRefresh(Date.now().toString());
        onAction();
        close();
    };

    const handleFilters = () => {
        open('common.filter.title', <AsignacionesTabFilter close={close} doFilter={doFilter} item={filters} />);
    };

    const handleShow = (item: any) => {
        navigate(`/assignments/${item.id}`)

    };

    const doFilter = (filters: any) => {
        //set('vehicles-filtroVehiculos', filters);
        setFilters(filters);
        close();
        //window.location.reload();
    };

    useEffect(() => {
        if (filters) {
            const filtrosGuardados = get('vehicles-filtroVehiculos');
            setQuery(
                new URLSearchParams({
                    ...filtrosGuardados,
                    ...filters
                })
            );
        }
    }, [filters]);


    return (
        <>

            <PageBody
                filterAction={handleFilters}
                filters={filters}
                title={'common.label.asignaciones'}
            >
                <>
                    {Object.keys(filters).length > 0 ? (
                        <RenderFilters filters={filters} />
                    ) : (
                        ''
                    )}
                    <Table
                        path={`/fleet/assignments/?vehicle=${item}&`}
                        query={query}
                        deletePath={`/fleet/assignments/`}
                        callBeforeDrawerClosed={handleClose}
                        onShow={(item: any) => handleShow(item)}
                        noEdit={true}
                        noDelete={true}
                        specialVersion={true}
                        withPagination
                        refresh={refresh}
                        headers={[
                            {
                                key: 'driver',
                                subKey: 'full_name',
                                label: 'common.label.conductor',
                            },
                            {
                                key: 'code',
                                label: 'common.label.codigo-asignacion',
                            },
                            {
                                key: 'assignment_datetime',
                                type: 'datetime',
                                label: 'common.label.fecha-hora-asignacion',
                            },
                            {
                                key: 'completion_datetime',
                                type: 'datetime',
                                label: 'common.label.fecha-hora-finalizacion',
                            },
                        ]}
                    />
                </>

            </PageBody>
        </>

    );
};